import React, {useEffect} from 'react'
import {useSelector} from 'react-redux'
import RenderedHtmlContent from "src/shared/virtual_congress/components/rendered_html_content";
import useLiquid from 'src/shared/service/use_liquid'

const ThankYouPage = () => {
  const tagOwner = useSelector(state => state.tagOwner)

  const isDeclining = useSelector(state => state.registrationPageState?.isDeclining)

  const thankYouText = useSelector(state => state.thankYouText)
  const thankYouHeadline = useSelector(state => state.thankYouHeadline)

  const declineConfirmationEnabled = useSelector(state => state.enable_decline_confirmation)
  const declineConfirmationText = useSelector(state => state.decline_confirmation_text)

  const thankYouRedirectEnabled = useSelector(state => state.thank_you_redirect_enabled)
  const thankYouRedirectUrl = useSelector(state => state.thank_you_redirect_url)
  const thankYouRedirectDelay = useSelector(state => state.thank_you_redirect_delay)

  const renderLiquid = useLiquid()

  useEffect(() => {
    let redirectTimeout = null
    if (thankYouRedirectEnabled && thankYouRedirectUrl && tagOwner) {
      const parsedThankYouRedirectUrl = renderLiquid(thankYouRedirectUrl.replace("@tag_owner_id@", tagOwner?.id))

      if (thankYouRedirectDelay && thankYouRedirectDelay >= 0) {
        redirectTimeout = setTimeout(function () {
          window.location = parsedThankYouRedirectUrl;
        }, thankYouRedirectDelay)
      } else {
        window.location = parsedThankYouRedirectUrl;
      }
    }

    return () => {
      if (redirectTimeout) {
        clearTimeout(redirectTimeout)
      }
    }
  }, [thankYouRedirectEnabled, thankYouRedirectUrl, tagOwner, renderLiquid])

  if (declineConfirmationEnabled && isDeclining) {
    return <div className="r-container row pb-4">
      <div className="r-header-text col">
        <div className="r-inner-container row">
          <div className="col">
            <RenderedHtmlContent html={declineConfirmationText}/>
          </div>
        </div>
      </div>
    </div>
  }

  return <div className="r-container row pb-4">
    <div className="r-header-text col">
      <div className="r-inner-container row">
        <div className="col">
          <RenderedHtmlContent html={thankYouText?.replace("@tag_owner_id@", tagOwner?.id)}/>
        </div>
      </div>
    </div>
  </div>
}
export default ThankYouPage;